import React from 'react'
import styled from 'styled-components'
import { WithAuth as Root } from '@/components/Root'
import { MonthlyScanReportsTable } from '@/components/tables/MonthlyScanReportsTable'
import { Layout, PageHeader } from 'antd'

const pageTitle = '月次集計結果'

export default () => (
  <Root title={pageTitle}>
    <Layout>
      <StyledPageHeader title={pageTitle} />
      <MonthlyScanReportsTable />
    </Layout>
  </Root>
)

const StyledPageHeader = styled(PageHeader)`
  margin: 16px 0;
  background-color: #fff;
`
